<template>
  <div class="h-full flex flex-col">
    <div class="flex justify-center border-solid border-b border-grey-100 pb-2 bg-white">
      <button :class="setupFromClasses" @click='step > 0 && selectStep(0)'>
        <div class="pbc-add-step-subtext">Add To</div>
        <div class="pbc-add-step-title">{{fromDbEntry.text}}</div>
      </button>
      <button :class="setupComponentClasses"  @click='step > 1 && selectStep(1)' :disabled='step <= 1'>
        <div class="pbc-add-step-subtext">When?</div>
        <div class="pbc-add-step-title">{{addedLinkTitle}}</div>
      </button>
      <button :class="setupComponentTypeClasses" @click='step > 2 && selectStep(2)' :disabled='step <= 2'>
        <div class="pbc-add-step-subtext">Setup</div>
        <div class="pbc-add-step-title">{{addedComponentTitle}}</div>
      </button>
    </div>

    <add-components class="add-main-area" v-if='step === 0' @select='selectComponentType' @next='$emit("next")' />

    <add-links v-if='step === 1' class="add-main-area"
        :component='component'
        :partutil='partutil'
        :transform='transform'
        :initial-selection='autolinkEngage'
        @select='selectLinkType'
        @next='$emit("next")' />

    <div v-else-if='step === 2' class="add-main-area">
      <component-details
        :key='addedComponent.id'
        :transform='transform'
        :component='addedComponent'
        :disable-toolbar-buttons='true'
        :partutil='partutil'
        :transforms-and-source='transformsAndSource'>
        <template #recommend='{}'>
          <recommender-links :gamedata='partutil.gamedata'
                            :partutil='partutil'
                            :component='addedComponent'
                            :transform='transform'
                            :short='true'
                            @select='selectRecommendation'
                            />
        </template>

      </component-details>
    </div>
  </div>
</template>
<script>
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import AddLinks from './AddLinks.vue';
import AddComponents from './AddComponents.vue';
import ComponentDetails from '@ui/molecules/ComponentDetails.vue';
import RecommenderLinks from '@ui/organisms/RecommenderLinks.vue';

import Partutil from '@edit/tree/partutil.js';
import Treeutil from '@edit/tree/treeutil.js';

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    links: {
      type: Array,
      required: true
    },
    components: {
      type: Array,
      required: true
    },
    autolink: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    const fromDbEntry = ComponentsDb.findDbEntry(this.component);
    // TODO: warning warning const {components, links} = this.transformsAndSource.from;
    const {components, links} = this;
    const treeutil = new Treeutil({
      components,
      links
    });
    return {
      step: 0,
      numSteps: 3,
      fromDbEntry,
      selectedLinkType: undefined,
      selectedComponentType: undefined,
      addedComponent: undefined,
      addedLink: undefined,
      treeutil,
      autolinkEngage: undefined
    }
  },
  components: {
    AddComponents,
    AddLinks,
    ComponentDetails,
    RecommenderLinks
  },
  methods: {
    next() {
      this.selectStep(this.step + 1);
    },
    selectLinkType({link}) {
      this.selectedLinkType = link;

      this.undo();

      console.log('sele!!!!!!!1', this.selectedComponentType);
      const newComponent = ComponentsDb.createComponent(this.selectComponentType.type, this.selectedComponentType);
      delete this.selectedComponentType.id;
      Object.assign(newComponent, this.addedComponent);

      const newLink = ComponentsDb.createLink(newComponent, this.selectedLinkType);
      console.log('newLink', newLink);
      const {addedComponents,addedLinks} = this.treeutil.addComponentWithLinkData(this.component, newLink, newComponent);
      console.log('ADDED COMPONENTS, ADDED LINKS', addedComponents, addedLinks);

      this.addedComponent = addedComponents[0];
      this.addedLink = addedLinks[0];

      this.addedComponents = addedComponents;
      this.addedLinks = addedLinks;

      this.$emit('validate-step', true);


    },
    selectComponentType({component}) {
      console.log('selectComponent Type', component);
      this.selectedComponentType = component;
      if (!component.__builtin) {
        this.addedComponent = ComponentsDb.createComponent(component.type);
      } else {
        this.addedComponent = ComponentsDb.createComponent(component.type, component);
        this.selectedComponentType = component;
      }
      this.$emit('validate-step', true);
    },
    undo() {
      if (!this.addedComponent) {
        return;
      }
      if (this.addedComponents && this.addedComponents.length) {
        console.log('undoing');
        this.treeutil.removeComponentsAndLinks(this.addedComponents || [], this.addedLinks || []);
      }
    },
    done() {
      // NOTE: this gets call by die Dialog component.
      // do not remove
      const {addedComponents, addedLinks} = this;
      this.$emit('add-components', {
        addedComponents,
        addedLinks
      });
    },
    recommend(link) {
      // NOTE: this gets call by die Dialog component.
      // do not remove
      const {addedComponents, addedLinks} = this;

      this.$emit('add-components', {
        addedComponents,
        addedLinks
      });

      this.$emit('add-recommendation', {
        link,
        addedComponents,
        addedLinks
      });
    },
    selectStep(newStep) {
      console.log('select step', this.step, this.newStep);
      if (this.step > newStep) {
        this.undo();
      }
      this.step = newStep;
    },
    selectRecommendation(link) {
      this.recommend(link);
    }
  },
  computed: {
    setupFromClasses() {
      return this.step === 0 ? ['pbc-add-step-active'] : ['pbc-add-step-completed'];
    },
    setupComponentTypeClasses() {
      return this.step === 2 ? ['pbc-add-step-active'] : (this.step < 2 ? ['pbc-add-step-waiting'] : ['pbc-add-step-completed']);
    },
    setupComponentClasses() {
      if (this.step === 1) {
        return ['pbc-add-step-active'];
      } else {
        if (this.step > 1) {
          return ['pbc-add-step-completed'];
        } else {
          return ['pbc-add-step-waiting'];
        }
      }
    },
    addedComponentTitle() {
      if (this.selectedComponentType) {
        return this.selectedComponentType.text;
      } else {
        return '??';
      }
    },
    addedLinkTitle() {
      if (this.selectedLinkType) {
        return this.selectedLinkType.title || this.selectedLinkType.description || this.selectedLinkType.name;
      } else {
        return '??';
      }
    },
  },
  watch: {
    step: {
      handler(nv) {
        this.$emit('change-step', nv, this.numSteps);
        this.$emit('validate-step', false);
        if (nv === 1 && this.autolinkEngage) {
          this.selectLinkType({link:this.autolinkEngage});
          this.$emit('validate-step', true);
        }
        if (this.$el) {
          this.$el.scrollIntoView({
            behavior: "smooth",
            block:"start"
          });
        }
      },
      immediate: true
    },
    autolink: {
      handler(nv) {
        console.log('have autolink', nv);
        if (nv && nv.name) {
          this.autolinkEngage = nv;
        }
      },
      immediate: true
    }
  }
}
</script>
